export default {
  isOverviewChartShown: 'Zobraziť prehľadový graf',
  isZoomedChartShown: 'Zobraziť graf priblížený na tolerančné pásmo',
  isSectionsTableShown: 'Zobraziť tabuľku úsekov',
};
